/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    error: null,
    loading: false,
    role: '',
    loadedPositions: []
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
      // get the UID from the current user
      state.user.id = firebase.auth().currentUser.uid
    },
    clearError (state) {
      state.error = null
    },
    logout (state, payload){
      state.user = payload
    },
    setUserRole (state, payload){
      state.role = payload
    },
    setLoadedPositions (state, payload){
      state.loadedPositions = payload
    }
  },
  actions: {
    signUserIn ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        .then(user => {
          commit('setLoading', false)
          const newUser = {
            id: user.uid
          }
          commit('setUser', newUser)
          // store.dispatch('getUserData')
        })
        .catch(error => {
          commit('setLoading', false)
          commit('setError', error)
        }
        )
    },

    signUserUp ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(
          user => {
            commit('setLoading', false)
            const newUser = {
              id: user.uid
            }
            commit('setUser', newUser)
          }
        )
        .catch(error => {
          commit('setLoading', false)
          commit('setError', error)
        }
        )
    },
    autoSignIn ({ commit }, payload) {
      commit('setUser', { id: payload.uid })
      commit('setLoading', false)
    },
    logout ({commit}) {
      firebase.auth().signOut()
      commit('logout', null)
    },
    addNewStudent ({ commit }, payload) {
      const newStudent = {
        role: payload.role,
        name: payload.name,
        gpa: payload.gpa,
        standing: payload.standing,
        experiences: payload.experiences,
        school: payload.school,
        id: firebase.auth().currentUser.uid
      }

      firebase.database().ref('Users').push(newStudent)
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
      })
    },

    addNewLab ({ commit }, payload) {
      const newLab = {
        name: payload.name,
        description: payload.description,
        imgURL: payload.imgURL,
        position: payload.position,
      }

      firebase.database().ref('Positions').push(newLab)
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
      })
    },
    loadPositions ({commit}){
      firebase.database().ref('Positions').once('value')
        .then((data) => {
          const positions = []
          const obj = data.val()
          for (let key in obj){
            //will only load providers that have been approved
            positions.push({
              id: key,
              name: obj[key].name,
              description: obj[key].description,
              position: obj[key].position,
              imgURL: obj[key].imgURL
            })
          }
          commit('setLoadedPositions', positions)
        })
        .catch((error) => {
          commit('setLoading', false)
          // eslint-disable-next-line
          console.log(error)
        })
    },

  },
  getters: {
    user (state) {
      return state.user
    },
    loadedPositions (state){
      return state.loadedPositions
    }
  }
})
